import { useTheme } from "@/services/theme";

export const useTableFilterIconColor = (filtered?: boolean) => {
  const theme = useTheme();

  if (!filtered) return undefined;

  return `${theme.colors.tableActiveFilter}`;
};
